import { defineMessages } from '@/components/formatted_message/FormattedMessage';

// WARNING: Use this translations and extend it if needed
// only for custom errors which do not have a corresponding form element type (e.g file attachments and other complex types)
// Most of the errors are translated in the src\containers\LanguageProvider\cs_CZ.ts and src\containers\LanguageProvider\sk_SK.ts
export const COMMON_FORM_ERRORS_TRANSLATED = defineMessages({
  attachmentsRequired: { id: 'app.common.form.errors.attachmentsRequired' },
  phone: { id: 'app.common.form.errors.phoneNumber' },
});
